<pmt-action-modal [title]="'assignments.assignmentsFilterModal.title' | transloco" [onlyCancel]="false"
    [cancelButtonText]="'assignments.assignmentsFilterModal.cancelButton' | transloco"
    [submitButtonText]="'assignments.assignmentsFilterModal.submitButton'" [submitButtonIconCode]="''"
    (submitted)="saveForm()" class="custom-modal-limiter" [isSaving]="false">
    <div class="d-flex flex-column gap-2">
        <form [formGroup]="filterForm" (ngSubmit)="saveForm()">
            <div class="container d-flex flex-column gap-3">
                <div class="d-flex flex-column gap-3">
                    <app-page-divider [text]="'assignments.assignmentsFilterModal.searchAndLevel.title'| transloco"
                        [icon]="'fa-solid fa-magnifying-glass'"></app-page-divider>

                    <!-- Filter Text Input -->
                    <div>
                        <label for="freeText">
                            {{"assignments.assignmentsFilterModal.searchAndLevel.search" | transloco}}
                        </label>
                        <div class="input-group">
                            <input id="freeText" type="text" formControlName="searchText"
                                [placeholder]="'shared.browse'| transloco" class="form-control" />
                            <button class="btn btn-sm btn-default" type="button"
                                (click)="filterForm.get('searchText')?.reset()">
                                <i class="fa-solid fa-xmark"></i>
                            </button>
                        </div>
                        <small class="form-text text-muted">
                            {{"assignments.assignmentsFilterModal.searchAndLevel.searchInfoText" | transloco}}
                        </small>
                    </div>
                </div>

                <!-- Time Period Input -->
                <app-page-divider [text]="'assignments.assignmentsFilterModal.timePeriod.title' | transloco"
                    [icon]="'fa-solid fa-clock'"></app-page-divider>
                <div class="d-flex flex-column gap-3">
                    <div>
                        <label for="dateFrom">
                            {{"assignments.assignmentsFilterModal.timePeriod.from" | transloco}}
                        </label>
                        <div class="input-group">
                            <div class="flex-grow-1">
                                <pmt-datepicker customTodayClass="bg-primary-subtle" id="dateFrom"
                                    formControlName="dateFrom" placement="bottom" [locale]="'de-CH'"></pmt-datepicker>
                            </div>
                            <button class="btn btn-sm btn-default" type="button"
                                (click)="filterForm.get('dateFrom')?.reset()">
                                <i class="fa-solid fa-xmark"></i>
                            </button>
                        </div>
                        <p class="text-danger" *ngIf="hasValidator('dateFrom','notBeforeToday')">
                            {{'assignments.assignmentsFilterModal.timePeriod.fromIsBeforeToday' | transloco}}
                        </p>
                    </div>
                    <div>
                        <label for="dateTo">
                            {{"assignments.assignmentsFilterModal.timePeriod.to" | transloco}}
                        </label>
                        <div class="input-group">
                            <div class="flex-grow-1">
                                <pmt-datepicker customTodayClass="bg-primary-subtle" id="dateTo"
                                    formControlName="dateTo" placement="bottom" [locale]="'de-CH'"></pmt-datepicker>
                            </div>
                            <button class="btn btn-sm btn-default" type="button"
                                (click)="filterForm.get('dateTo')?.reset()">
                                <i class="fa-solid fa-xmark"></i>
                            </button>
                        </div>
                        <p class="text-danger" *ngIf="hasValidator('dateTo','greaterOrEqualThan')">
                            {{'assignments.assignmentsFilterModal.timePeriod.toIsBeforeFrom' | transloco}}
                        </p>
                    </div>
                    <div class="d-flex justify-content-between">
                        <label for="show-weekdays">
                            {{"assignments.assignmentsFilterModal.filterWeekdays" | transloco}}
                        </label>
                        <div class="form-check form-switch">
                            <input id="show-weekdays" type="checkbox" class="form-check-input"
                                formControlName="isWeekdayFilterActive" />
                        </div>
                    </div>
                </div>

                <!-- Week Days Input (Bootstrap Switches) -->
                <ng-container *ngIf="filterForm.get('isWeekdayFilterActive')?.value">
                    <div>
                        <app-page-divider [text]="'shared.weekdays.title' | transloco"
                            [icon]="'fa-solid fa-calendar'"></app-page-divider>
                        <div [formGroup]="filterForm">
                            <div formGroupName="weekdays">
                                <!-- Monday -->
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <label class="me-auto" for="weekday-monday">
                                        {{"shared.weekdays.long.1" | transloco}}
                                    </label>
                                    <div class="form-check form-switch">
                                        <input id="weekday-monday" type="checkbox" class="form-check-input"
                                            formControlName="isMondayActive" />
                                    </div>
                                </div>

                                <!-- Tuesday -->
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <label class="me-auto" for="weekday-tuesday">
                                        {{"shared.weekdays.long.2" | transloco}}
                                    </label>
                                    <div class="form-check form-switch">
                                        <input id="weekday-tuesday" type="checkbox" class="form-check-input"
                                            formControlName="isTuesdayActive" />
                                    </div>
                                </div>

                                <!-- Wednesday -->
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <label class="me-auto" for="weekday-wednesday">
                                        {{"shared.weekdays.long.3" | transloco}}
                                    </label>
                                    <div class="form-check form-switch">
                                        <input id="weekday-wednesday" type="checkbox" class="form-check-input"
                                            formControlName="isWednesdayActive" />
                                    </div>
                                </div>

                                <!-- Thursday -->
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <label class="me-auto" for="weekday-thursday">
                                        {{"shared.weekdays.long.4" | transloco}}
                                    </label>
                                    <div class="form-check form-switch">
                                        <input id="weekday-thursday" type="checkbox" class="form-check-input"
                                            formControlName="isThursdayActive" />
                                    </div>
                                </div>

                                <!-- Friday -->
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <label class="me-auto" for="weekday-friday">
                                        {{"shared.weekdays.long.5" | transloco}}
                                    </label>
                                    <div class="form-check form-switch">
                                        <input id="weekday-friday" type="checkbox" class="form-check-input"
                                            formControlName="isFridayActive" />
                                    </div>
                                </div>

                                <!-- Saturday -->
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <label class="me-auto" for="weekday-saturday">
                                        {{"shared.weekdays.long.6" | transloco}}
                                    </label>
                                    <div class="form-check form-switch">
                                        <input id="weekday-saturday" type="checkbox" class="form-check-input"
                                            formControlName="isSaturdayActive" />
                                    </div>
                                </div>

                                <!-- Sunday -->
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <label class="me-auto" for="weekday-sunday">
                                        {{"shared.weekdays.long.7" | transloco}}
                                    </label>
                                    <div class="form-check form-switch">
                                        <input id="weekday-sunday" type="checkbox" class="form-check-input"
                                            formControlName="isSundayActive" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <!-- Button -->
                <div>
                    <button type="button" class="btn btn-sm btn-default w-100" (click)="clearForm()">
                        {{"assignments.assignmentsFilterModal.clearButton" | transloco}}
                    </button>
                </div>
            </div>
        </form>
    </div>
</pmt-action-modal>